module.exports = __webpack_public_path__ + "img/xlsx.84a3ab8a.png";